import { render, staticRenderFns } from "./BrandSection.vue?vue&type=template&id=e445f976&scoped=true"
import script from "./BrandSection.vue?vue&type=script&lang=js"
export * from "./BrandSection.vue?vue&type=script&lang=js"
import style0 from "./BrandSection.vue?vue&type=style&index=0&id=e445f976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e445f976",
  null
  
)

export default component.exports